import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import strings from "../../config/localization";
import { useResetPwdMutation } from "../../services/appln";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Formik, Form, FormikErrors } from "formik";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LockResetIcon from "@mui/icons-material/LockReset";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { getMinPasswordLength } from "../constants";

interface FormData {
  name: string;
  newPasswd: string;
}

interface Props {
  title: string;
  userId: string;
  initialValues: any;
}

export default function ResetPwd({ title, userId, initialValues }: Props) {
  console.log("initial values", initialValues);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [resetPwd, resetPwdParams] = useResetPwdMutation();

  const iv: FormData = {
    name: initialValues.row.name,
    newPasswd: "",
  };

  if (resetPwdParams.isLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (resetPwdParams.isUninitialized || resetPwdParams.isSuccess) {
    // trigger not called yet, show form
    return (
      <div>
        <Button
          variant="outlined"
          size="small"
          startIcon={<LockResetIcon />}
          onClick={handleClickOpen}
        >
          {strings.resetPwd}
        </Button>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title"> {title} </DialogTitle>
          <DialogContent>
            <Formik
              initialValues={iv}
              validate={(values) => {
                const errors: FormikErrors<FormData> = {};
                if (values.newPasswd.length < getMinPasswordLength()) {
                  errors.newPasswd = strings.formatString(
                    strings.shortPassword,
                    getMinPasswordLength(),
                  ) as string;
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                handleClose();
                console.log("in reset pwd, values", values);
                resetPwd({
                  ...values,
                  userId: userId,
                });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => (
                <Form>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          disabled
                          margin="normal"
                          id="name"
                          name="name"
                          label={strings.name}
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.name && Boolean(errors.name)}
                          helperText={touched.name && errors.name}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          margin="normal"
                          type="password"
                          id="newPasswd"
                          name="newPasswd"
                          label={strings.newPasswd}
                          value={values.newPasswd}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.newPasswd && Boolean(errors.newPasswd)}
                          helperText={touched.newPasswd && errors.newPasswd}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {" "}
                          {strings.update}{" "}
                        </Button>
                      </Grid>
                      <Grid item xs={3}>
                        <Button variant="contained" onClick={handleClose}>
                          {" "}
                          {strings.cancel}{" "}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  // // should never be here..
  return <h1>wierd state !</h1>;
}
